/// <reference types="fhir" />
import { Action, createReducer, on } from '@ngrx/store';

import { dawbaSpecificActions } from './dawba-specific.actions';

export const dawbaSpecificFeatureKey = 'dawba-specific';

export interface IDawbaSpecificState {
  carePlanLoaded: boolean;
  dawbaUserType: 'Patient' | 'RelatedPerson';
  dawbaRelationType: 'self' | 'familyOrCaretaker' | 'educationalStaff'
  patientAgeGroup: string;
  patientName: string;
  patientFhirId: string;
  patientGender: string;
  curCarePlanId: string;
}

export const initialState: IDawbaSpecificState = {
  carePlanLoaded: false,
  dawbaUserType: null,
  dawbaRelationType: null,
  patientAgeGroup: null,
  patientFhirId: null,
  patientGender: null,
  patientName: null,
  curCarePlanId: null,
};

export const reducer = createReducer(
  initialState,
  on(
    dawbaSpecificActions.initPrimaryFhirLoad,
    (state, _action): IDawbaSpecificState => ({
      ...state,
    })
  ),
  on(
    dawbaSpecificActions.primaryFhirLoadSuccess,
    (state, _action): IDawbaSpecificState => ({
      ...state,
    })
  ),
  on(
    dawbaSpecificActions.primaryFhirLoadFailure,
    (state, _action): IDawbaSpecificState => ({
      ...state,
    })
  ),
  on(
    dawbaSpecificActions.update,
    (state, action): IDawbaSpecificState => ({
      ...state,
      ...action.update,
    })
  ),
  on(
    dawbaSpecificActions.resetState,
    (_state, _action): IDawbaSpecificState => initialState
  ),
  on(
    dawbaSpecificActions.setCurCarePlan,
    (state, action): IDawbaSpecificState => ({
      ...state,
      ...action,
      carePlanLoaded: true
    })
  )
);

export function dawbaSpecificReducer(
  state: IDawbaSpecificState | undefined,
  action: Action
) {
  return reducer(state, action);
}
